import { render } from "./BaseTag.vue?vue&type=template&id=d0aa8e8e&scoped=true"
import script from "./BaseTag.vue?vue&type=script&lang=js"
export * from "./BaseTag.vue?vue&type=script&lang=js"

import "./BaseTag.vue?vue&type=style&index=0&id=d0aa8e8e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0aa8e8e"]])

export default __exports__